import * as React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { userAction } from "../../actions/user.action";
import { appAction } from "../../actions/app.action";
import Email from "@material-ui/icons/Email";
import Phone from "@material-ui/icons/Phone";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Button from "@material-ui/core/Button/Button";
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableBody from "@material-ui/core/TableBody/TableBody";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel/TableSortLabel";
import Typography from "@material-ui/core/Typography/Typography";
import SectionHeader from "../../components/UI/SectionHeader";
import DateRange from "../../components/Forms/DateRange";
import withStyles from "@material-ui/core/styles/withStyles";
import { formatDate, formatPhone } from "../../utilities/format";
import { sortAdvisorDetail, stableSort } from "../../utilities/sorting";
import { withinDateRange } from "../../utilities/filter";
import Grid from "@material-ui/core/Grid";
import AdvisorInfoCard from "./components/AdvisorInfoCard";
import { AdvisorFeeSummaryCard } from "../Cy/components";
import feeAction from "../../actions/fee.action";

const styles = (theme) => ({
  header: {
    [theme.breakpoints.down("md")]: {
      display: "inline-block",
    },
  },
  table: {
    "& th": {
      color: theme.palette.primary.main,
      fontSize: 14,
      padding: "4px 10px",
      fontWeight: 500,
      height: "48px",
    },
    "& td": {
      fontSize: 14,
      padding: "4px 10px",
      [theme.breakpoints.down("md")]: {
        padding: "2px",
        fontSize: 12,
      },
    },
  },
  contact: {
    whiteSpace: "nowrap",
    "& svg": {
      fontSize: 16,
      marginRight: "2%",
      verticalAlign: "middle",
      color: "rgba(0, 0, 0, 0.54)",
    },
  },
  actionBtn: {
    fontSize: 12,
    textTransform: "none",
    width: "105px",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      whiteSpace: "nowrap",
      minWidth: 89,
      maxWidth: 89,
      minHeight: 24,
      lineHeight: 0.8,
    },
  },
});

// Advisor class - where displays the client household data when clicking the list of
// the advisor from /admin screen
class AdvisorDetail extends React.Component {
  state = {
    order: "desc",
    orderBy: "",
    columns: [
      {
        id: "tableView.clientName",
        numeric: false,
        label: "Client",
        sortable: true,
      },
      {
        id: "tableView.clientEmail",
        numeric: false,
        label: "Contact",
        sortable: true,
      },
      {
        id: "tableView.spouseName",
        numeric: false,
        label: "Spouse",
        sortable: true,
      },
      {
        id: "createdAt",
        numeric: false,
        label: "Created",
        sortable: true,
      },
      {
        id: "tableView.onboarded",
        numeric: false,
        label: "# Onboarded",
        sortable: true,
        extraOrdering: [["asc", "clientName"]],
      },
      {
        id: "action",
        numeric: false,
        label: "",
      },
    ],
    filterCreated: {
      from: null,
      to: null,
    },
  };

  componentDidMount() {
    this.props.dispatch(userAction.getUserById(this.props.match.params.id));
    this.props.dispatch(appAction.toggleMainNav(false));
    this.props.dispatch(appAction.setAdminNav(true));
    window.scrollTo(0, 0);
  }

  handleRequestSort = (event, property, extraOrdering) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy, extraOrdering });
  };

  createSortHandler = (property, extraOrdering) => (event) => {
    this.handleRequestSort(event, property, extraOrdering);
  };

  // Redirect to the advisor lists (main admin dashboard screen)
  /* Redirect to the Household screen */
  redirectToHousehold = (householdId) => {
    this.props.history.push(
      `/Portal/admin/household/${householdId}?fromAdvisor=${this.props.advisor.id}`
    );
  };

  applyFilters = (households = []) => {
    return households.filter((household) => {
      const date = household.createdAt;
      const range = this.state.filterCreated;
      return !date || withinDateRange(date, range);
    });
  };

  saveFeeSchedules = (entityType, entityId, feeSchedules) => {
    const { advisor, dispatch, userPlatformFees } = this.props;

    if (entityType === "custodian") {
      dispatch(
        feeAction.updateAdvisorCustodian(feeSchedules, advisor.id, entityId)
      );
    } else if (entityType === "platform") {
      const overridePlatformFees = [...feeSchedules];
      if (!userPlatformFees) {
        // If advisor doesn't have an overridden platformFee, then remove id from to server can create new records
        overridePlatformFees.forEach((fee) => {
          delete fee.id;
        });
      }
      dispatch(
        feeAction.updateAdvisorPlatform(overridePlatformFees, advisor.id)
      );
    } else {
      throw new Error("unknown action");
    }
  };

  render() {
    const { columns, order, orderBy, extraOrdering } = this.state;
    const {
      advisor,
      classes,
      custodians,
      cyPlatformFees,
      userCustodianFees,
      userPlatformFees,
    } = this.props;

    const absoluteUserPlatformFees =
      userPlatformFees && userPlatformFees.length
        ? userPlatformFees
        : cyPlatformFees;
    const householdList = this.applyFilters(advisor.households);
    const sortedHouseholdList = stableSort(
      householdList,
      sortAdvisorDetail(order, orderBy, extraOrdering)
    );

    return (
      <React.Fragment>
        <SectionHeader text="Advisor Book" className={classes.header} />
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <AdvisorInfoCard advisor={advisor} />
          </Grid>
          <Grid item xs={12} md={4}>
            <AdvisorFeeSummaryCard
              custodians={custodians}
              custodianFees={userCustodianFees}
              platformFees={absoluteUserPlatformFees}
              onSaveFeeSchedules={this.saveFeeSchedules}
              platformFeeOverrideDisabled={true}
            />
          </Grid>
        </Grid>

        <div className="fiters" onClick={(e) => e.preventDefault()}>
          <label style={{ display: "block", marginBottom: "0.5em" }}>
            <Typography>Search by Client Created Date:</Typography>
            <DateRange
              onChange={(dateRange) =>
                this.setState({ filterCreated: dateRange })
              }
            />
          </label>
        </div>
        <section>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  return (
                    <TableCell
                      key={column.id}
                      align={column.numeric ? "right" : "left"}
                      sortDirection={orderBy === column.id ? order : false}
                    >
                      {column.sortable ? (
                        <Tooltip title="Sort" placement="top" enterDelay={300}>
                          <TableSortLabel
                            active={orderBy === column.id}
                            direction={order}
                            onClick={this.createSortHandler(
                              column.id,
                              column.extraOrdering
                            )}
                          >
                            {column.label}
                          </TableSortLabel>
                        </Tooltip>
                      ) : (
                        column.label
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {householdList.length > 0 ? (
                sortedHouseholdList.map((household) => (
                  <TableRow
                    key={household.id}
                    hover
                    style={{ cursor: "pointer" }}
                    onClick={() => this.redirectToHousehold(household.id)}
                  >
                    <TableCell>{household.tableView.clientName}</TableCell>
                    <TableCell>
                      <div className={classes.contact}>
                        {household.tableView.clientEmail && (
                          <React.Fragment>
                            <Email />
                            {household.tableView.clientEmail}
                          </React.Fragment>
                        )}
                      </div>
                      <div className={classes.contact}>
                        {household.tableView.clientPhone && (
                          <React.Fragment>
                            <Phone />
                            {formatPhone(household.tableView.clientPhone)}
                          </React.Fragment>
                        )}
                      </div>
                    </TableCell>
                    <TableCell>
                      {household.tableView.spouseName &&
                        household.tableView.spouseName}
                    </TableCell>
                    <TableCell>
                      {household.createdAt && formatDate(household.createdAt)}
                    </TableCell>
                    <TableCell>
                      {household.Portfolios.filter((p) => p.onboarded).length}
                    </TableCell>
                    <TableCell>
                      <Link
                        to={`/Portal/admin/household/${household.id}?fromAdvisor=${advisor.id}`}
                      >
                        <Button
                          variant="contained"
                          size={"small"}
                          className={classes.actionBtn}
                        >
                          View Household
                        </Button>
                      </Link>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} style={{ textAlign: "center" }}>
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { custodians } = state.custodian;
  const { id } = ownProps.match.params;

  const { cyPlatformFees, userCustodianFees, userPlatformFees } = state.fee;

  return {
    custodians,
    advisor: state.user.selectedUser,
    userCustodianFees: userCustodianFees[id],
    userPlatformFees: userPlatformFees[id],
    cyPlatformFees,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(AdvisorDetail));



// WEBPACK FOOTER //
// ./src/containers/AdminAdvisorDetail/index.jsx